<template>
    <el-dialog
        v-model="dialogVisible"
        width="400px"
        align-center
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape=" false"
        >
        <template #header="{ titleId }">
            <div class="dialog_header flexMainXYcenter justify-between">
                <div class="flexMainXYcenter">
                    <img class="prompt_icon flexShrink" src="@/assets/images/layout/prompt_icon.png" alt="">
                    <div class="tit" :id="titleId" v-if="requestCode == 217">账号已登出</div>
                    <div class="tit" :id="titleId" v-if="requestCode == 205">提示</div>
                </div>
                <img class="close_icon" @click="closeDialog" src="@/assets/images/layout/close_icon.png" alt="">
            </div>
        </template>
        <div class="dialog_body">
            <template v-if="requestCode == 217">
                <div class="dialog_msg mgb4">你的帐号（{{encryptionPhone}}）已在其他设备上登录</div>
                <div class="dialog_msg">请刷新页面或重新登录</div>
            </template>
            <div class="dialog_msg" v-if="requestCode == 207">登录态失效，请刷新重试或重新登录</div>
        </div>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="closeDialog" class="normal_btn" v-if="requestCode == 217">取消</el-button>
            <el-button @click="reloadHandle" class="normal_btn btn_style" v-if="requestCode == 205">刷新</el-button>
            <el-button type="primary" class="beauty_btn" style="margin-left: 12px;" @click="reLoginHandle">重新登录</el-button>
        </div>
        </template>
    </el-dialog>
</template>

<script setup>
    import { ref, onMounted } from 'vue'
    import { storeToRefs } from 'pinia';
    import { useUserStore } from '@/store';
    import { useRoute, useRouter } from 'vue-router';
    const route = useRoute();
    
    const router = useRouter();
    const props = defineProps(['loginOutShow'])
    const emits = defineEmits(['closeLoginOutDialog','reloginHandle'])
    const dialogVisible = ref(false);
    const { access, requestCode, encryptionPhone } = storeToRefs(useUserStore());
    const store = useUserStore();

    function closeDialog(){
        dialogVisible.value = false;
        if(routerJudge()){
            console.log('3333')
            router.push({ path: '/'})
            setTimeout(()=>{
                store.loginOut();
            },1000)
        }else{
            store.loginOut();
        }
        
        emits('closeLoginOutDialog')
    }
    function reLoginHandle(){
        dialogVisible.value = false;
        store.loginOut('relogin');
        emits('reloginHandle')
    }

    function routerJudge(){
        if(route.path == '/edit'){
            return true
        }else{
            return false
        }
    }
    
    function reloadHandle(){
        if(routerJudge()){
            router.push({ path: '/'})
            setTimeout(()=>{
                store.loginOut();
            },1000)
        }else{
            store.loginOut();
        }
    }

    onMounted(()=>{
        dialogVisible.value = props.loginOutShow
    })
</script>

<style lang="scss" scoped>
    
</style>